import { cn } from 'cn';

const pillThemes = [
  'default',
  'green',
  'red',
  'blue',
  'purple',
  'yellow',
  'teal',
] as const;

export type PillTheme = (typeof pillThemes)[number];

type PillProps = {
  text?: string | number;
  theme?: PillTheme;
  className?: string;
  bold?: boolean;
};

const baseClasses =
  'typ-headline-3xs font-bold px-1 rounded-sm flex items-center h-4 w-fit';

const siteThemeClasses = cn('kunde:px-2 kunde:py-3 kunde:text-xs');

const themes: Record<PillTheme, (bold: boolean) => string> = {
  default: (bold) =>
    cn(bold ? 'bg-neutral-110 text-white' : 'bg-neutral-10 text-neutral-110'),
  green: (bold) =>
    cn(bold ? 'bg-green-100 text-white' : 'bg-green-10 text-neutral-110'),
  red: (bold) =>
    cn(
      bold
        ? 'bg-red-100 text-white'
        : 'bg-red-10 text-red-110 kunde:text-neutral-200',
    ),
  blue: (bold) =>
    cn(bold ? 'bg-blue-60 text-white' : 'bg-blue-10 text-blue-110'),
  purple: (bold) =>
    cn(bold ? 'bg-purple-60 text-neutral-200' : 'bg-purple-10 text-purple-110'),
  yellow: (bold) =>
    cn(
      bold ? 'bg-orange-60 text-neutral-200' : 'bg-orange-10 text-neutral-110',
    ),
  teal: (bold) =>
    cn(bold ? 'bg-teal-60 text-neutral-200' : 'bg-teal-10 text-neutral-110'),
};

function Pill({
  text,
  theme = 'default',
  className,
  bold = false,
  ...rest
}: PillProps) {
  if (!text) return null;
  return (
    <span
      data-testid="pill"
      className={cn(
        baseClasses,
        themes[theme](bold),
        siteThemeClasses,
        className,
      )}
      {...rest}
    >
      <span>{text}</span>
    </span>
  );
}

export default Pill;
